/* eslint-disable react/prop-types */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useCallback, useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useTranslator } from '@jutro/locale';
import { QuestionSetComponent, platformMessages } from 'ml-components-platform-react';
import { MLAddressDetailsComponent } from 'ml-components-common-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { MLNotificationBlockUtil } from 'ml-portals-util-react';
import '@xengage/gw-platform-translations';
import classNames from 'classnames';
import appConfig from 'app-config';
import _ from 'lodash';
import { useDependencies } from '@xengage/gw-portals-dependency-react';

import messages from './LocationPopupComponent.messages';
import metadata from './LocationPopupComponent.metadata.json5';
import styles from './LocationPopupComponent.module.scss';

function LocationPopupComponent(props) {
    const translator = useTranslator();

    const {
        id,
        onValidate,
        showValidationErrors,
        locationVM,
        pupModel,
        onModelChange,
        syncExposure,
        onSave,
        getUnderlyingPolicies,
        createUnderlyingPolicy,
        quoteID,
        isEndorsement,
        showAnimalExclusionWarningMessage,
        validateBeforeSave,
        showActionRow,
        showProgressDialog,
        onCancel,
        errorTimestamp,
        setErrorTimestamp,
        submissionVM
    } = props;

    const {
        clearBlockAlerts,
        addErrorAlert
    } = MLNotificationBlockUtil();

    const isAMP = appConfig.portalCode === 'AMP';
    const isGPA = appConfig.portalCode === 'GPA';
    const [showErrors, updateShowErrors] = useState(showValidationErrors);
    const [showPolicyLocationQuestionSet, setShowPolicyLocationQuestionSet] = useState(locationVM.locationQuestionSet.value !== undefined);
    const [locationError, setLocationError] = useState(null);
    const underlyingPolicies = pupModel.underlyingPolicies.value;
    let isInSync = false;
    const isPersonalUmbrella = submissionVM.value.isPersonalUmbrella();
    const isModernProduct = _.get(submissionVM, 'isModernProduct_Ext.value', false);
    const isUMB_NP = isPersonalUmbrella && isModernProduct;
    const exposureType = 'location';
    const policyLocation = 'PUPPolicyLocation_ML';
    const locationAnimals = 'PUPLocationAnimals_ML';
    const policyLocationHasAnimals = 'PUPPolicyLocationHasAnimals_ML';
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const { EndorsementService } = useDependencies('EndorsementService');
    const { authHeader } = useAuthentication();
    const { refreshData } = useDataRefresh();
    let policyLocationQuestionSet;
    let locationAnimalsQuestionSet;
    let showAnimalQuestions;
    const [questionSetSyncing, setQuestionSetSyncing] = useState(false);
    const [questionSetSyncPromise, setQuestionSetSyncPromise] = useState(null);
    const LEGACY_RESIDENCE_TYPES = ['Fam1', 'Fam2', 'Fam3', 'Fam4', 'Fam5'];
    const LEGACY_LOCATION_TYPES = ['Dwelling', 'VacantLand'];

    const hasAnimalQuestionsToShow = () => {
        return policyLocationQuestionSet && (policyLocationQuestionSet.answers[policyLocationHasAnimals] === 'true' || policyLocationQuestionSet.answers[policyLocationHasAnimals] === true);
    };

    if (locationVM.locationQuestionSet.questionSets && locationVM.locationQuestionSet.questionSets.value) {
        const locationQuestionSet = locationVM.locationQuestionSet.questionSets.value;
        if (locationQuestionSet) {
            policyLocationQuestionSet = locationQuestionSet[locationQuestionSet.findIndex((qs) => qs.code === policyLocation)];
            locationAnimalsQuestionSet = locationQuestionSet[locationQuestionSet.findIndex((qs) => qs.code === locationAnimals)];
            showAnimalQuestions = hasAnimalQuestionsToShow();
        }
    }

    useEffect(() => {
        if (showValidationErrors) {
            updateShowErrors(showValidationErrors)
        }
    }, [showValidationErrors])


    const checkQuestionSetSync = (serviceCall) => {
      let updatePromise;
      if (questionSetSyncing && questionSetSyncPromise) {
        console.log("Waiting for questionSetSyncing to finish...");
        updatePromise = questionSetSyncPromise.then(() => {
          let promise = serviceCall();
          showProgressDialog(
            platformMessages.syncingQuestions,
            promise,
            true,
            0
          );
          return promise;
        });
      } else {
        updatePromise = serviceCall();
        showProgressDialog(
            platformMessages.syncingQuestions,
            updatePromise,
            true,
            0
        );
      }

      setQuestionSetSyncing(true);
      setQuestionSetSyncPromise(updatePromise);
      return updatePromise;
    };

    const onQuestionSetValueChange = (aQuestionSetAnswersValue, path, qsQuestionType) => {
        // For String type, we just update model locally and wait for the blur event to sync.
        if(qsQuestionType === "String"){
            onModelChange(locationVM);
            return;
        }

 // Reset all animal questions to false when policyLocationHasAnimals is set to No/false
        const hasAnimalsAnswer = aQuestionSetAnswersValue?.answers?.[policyLocationHasAnimals];
        const isHasAnimalsQuestion = aQuestionSetAnswersValue?.code === policyLocation;
        let resetAnimalQuestionSet = null;
        if (isHasAnimalsQuestion && (hasAnimalsAnswer === 'false' || hasAnimalsAnswer === false)) {
            const questionSets = _.get(locationVM, 'locationQuestionSet.questionSets.value', []);
            const animalQSIndex = questionSets.findIndex((qs) => qs.code === locationAnimals);
            if (animalQSIndex !== -1 && questionSets[animalQSIndex]?.answers) {
                const animalQuestionsToReset = [
                    'PUPLocationAnimalsDog1_ML',
                    'PUPLocationAnimalsAnimalEverBit_ML',
                    'PUPLocationAnimalsAnotherDog1_ML',
                    'PUPLocationAnimalsExoticAnimal_ML',
                    'PUPLocationAnimalsFarmAnimal_ML',
                    'PUPLocationAnimalsOtherAnimal1_ML'
                ];
                animalQuestionsToReset.forEach((question) => {
                    questionSets[animalQSIndex].answers[question] = 'false';
                });
                _.set(locationVM, 'locationQuestionSet.questionSets.value', questionSets);
                resetAnimalQuestionSet = questionSets[animalQSIndex];
                onModelChange(locationVM);
            }
        }
        const qsDto = {
            QuestionSets: resetAnimalQuestionSet
                ? [aQuestionSetAnswersValue, resetAnimalQuestionSet]
                : [aQuestionSetAnswersValue],
            ShouldDispalyAnimalExclusionWarning_ML: null
        };
        let syncPromise;

        if (isEndorsement) {
            syncPromise = checkQuestionSetSync(() => EndorsementService.syncLocationQuestionSet(quoteID, locationVM.publicID.value, qsDto, authHeader));
        } else {
            syncPromise = checkQuestionSetSync(() => LoadSaveService.syncLocationQuestionSet(quoteID, locationVM.publicID.value, qsDto, authHeader));
        }
        // showProgressDialog(platformMessages.syncing, syncPromise);

        syncPromise.then((updatedQuestions) => {
            _.set(locationVM, 'locationQuestionSet.value', updatedQuestions);
            onModelChange(locationVM);
            if (showAnimalExclusionWarningMessage && isEndorsement) {
                showAnimalExclusionWarningMessage({shouldShow: updatedQuestions.shouldDispalyAnimalExclusionWarning_ML});
            } else if (showAnimalExclusionWarningMessage) {
                showAnimalExclusionWarningMessage(updatedQuestions.shouldDispalyAnimalExclusionWarning_ML);
            }
        }).finally(() => {
            setQuestionSetSyncing(false);
            setQuestionSetSyncPromise(null);
        });
    };

    /**
     * For fields type "String", we're not updating each keystroke, instead we wait for the user to finish and read 'blur'.
     * @param {Object} evt 
     * @param {Object} object 
     * @param {String} qsQuestionType 
     */
    const onQuestionSetStringBlur = (evt, object, qsQuestionType) => {
        if(qsQuestionType !== "String"){
            return;
        }
        let qsDto = {};
        if(_.has(evt, 'answers.PUPDescOfSeparateStruct_Ext')) {
            qsDto = {
            QuestionSets: [_.get(locationVM, 'locationQuestionSet.questionSets.value[0]')],
            ShouldDispalyAnimalExclusionWarning_ML: null
            };
        } else{
           qsDto = {
            QuestionSets: [_.get(locationVM, 'locationQuestionSet.questionSets.value[1]')],
            ShouldDispalyAnimalExclusionWarning_ML: null
            };
        }
        let syncPromise;

        if (isEndorsement) {
            syncPromise = checkQuestionSetSync(() => EndorsementService.syncLocationQuestionSet(quoteID, locationVM.publicID.value, qsDto, authHeader));
        } else {
            syncPromise = checkQuestionSetSync(() => LoadSaveService.syncLocationQuestionSet(quoteID, locationVM.publicID.value, qsDto, authHeader));
        }
        // showProgressDialog(platformMessages.syncing, syncPromise);

        syncPromise.then((updatedQuestions) => {
            _.set(locationVM, 'locationQuestionSet.questionSets.value', updatedQuestions.questionSets);
            onModelChange(locationVM);
            if (showAnimalExclusionWarningMessage) {
                showAnimalExclusionWarningMessage({shouldShow: updatedQuestions.shouldDispalyAnimalExclusionWarning_ML});
            }           
        }).finally(() => {
            setQuestionSetSyncing(false);
            setQuestionSetSyncPromise(null);
        });
    }

    const mapAvailableValues = (values) => {
        return values.map((type) => {
            return {
                code: type.code,
                name: translator({
                    id: type.name,
                    defaultMessage: type.name
                })
            };
        });
    };

    const getAvailableLocationTypes = () => {
        const availableLocationTypes = mapAvailableValues(
        locationVM.locationType.aspects.availableValues || []
        );

        if (!isUMB_NP) {
        return availableLocationTypes.filter((type) =>
            LEGACY_LOCATION_TYPES.includes(type.code)
        );
        }

        return availableLocationTypes;
    };

    const getAvailableResidenceTypes = () => {
        const availableResidenceTypes = mapAvailableValues(
        locationVM.residenceType.aspects.availableValues
        );
        
        if (isUMB_NP) {
        return availableResidenceTypes.filter(
            (type) => !LEGACY_RESIDENCE_TYPES.includes(type.code)
        );
        }
        return availableResidenceTypes;
    };

    const getAvailableDwellingOccupancies = () => {
        const allValues = locationVM.dwellingOccupancy.aspects.availableValues || [];
 
        const filteredValues = isUMB_NP
            ? allValues.filter((value) => value.code !== 'nonown')
            : allValues;
   
        return mapAvailableValues(filteredValues);
    };

    const getAvailableDwellingUsages = () => {
        const occupancy = locationVM.dwellingOccupancy.value?.code;
        const tenant_Values = ["sec", "seas", "rent"];
        const owner_Values = ["prim", "sec", "seas"];
        let allValues = locationVM.dwellingUsage.aspects.availableValues;

        if (!occupancy) {
            return mapAvailableValues(allValues);                                         
        }

        let allowedCodes = [];

        switch (occupancy) {
            case "tenant":
            allowedCodes = tenant_Values;
            break;

            case "owner":
            allowedCodes = owner_Values;
            break;

            case "Rented_by_Insured":
                if(isUMB_NP) {
                    allowedCodes = owner_Values;
                } else{
                    allowedCodes = allValues.map(v => v.code);
                }
            break;

            default:
            allowedCodes = allValues.map(v => v.code);
        }

         const filtered = allValues.filter(v => allowedCodes.includes(v.code));
         const mapped = mapAvailableValues(filtered);

         if(occupancy === "tenant"){
            const rentOption = allValues.find(v => v.code === "rent");

            if(rentOption){
                locationVM.dwellingUsage.value = rentOption;
            };
         };

        return mapped;
    };

    const notVacantLand = () => {
        return locationVM.locationType.value === undefined
            || locationVM.locationType.value.code !== 'VacantLand';
    };

    const { onValidate: setComponentValidation, isComponentValid } = useValidation(id);
    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid, id);
        }
    }, [id, onValidate, isComponentValid]);

    const addNewUnderlyingPolicyIfNew = () => {
        if(createUnderlyingPolicy){
            Promise.resolve(createUnderlyingPolicy(exposureType)).then((model) => {
                let val;
                if(model){
                    val = model.ulPolicyFixID.value;
                }
                locationVM.ulPolicyFixID.value = val;
                onModelChange(locationVM);
                refreshData();
            })
        }
    };

    const validateAndSyncExposure = () => {
        const isValid = locationVM.aspects.valid && locationVM.aspects.subtreeValid && !validateBeforeSave() && !locationVM.locationQuestionSet.value;
        if (isValid) {
            locationVM.value.isSelected = true;
            const syncExposurePromise = syncExposure(locationVM.value);
            showProgressDialog(platformMessages.syncing, syncExposurePromise);
            syncExposurePromise.then((location) => {
                _.set(locationVM, 'value', location.value);
                setShowPolicyLocationQuestionSet(locationVM.locationQuestionSet.value !== undefined);
                onModelChange(locationVM);
            });
        }
    };

    const performSync = useCallback(() => {
        locationVM.value.isSelected = true;
        if (isInSync === false) {
            isInSync = true;
            const syncExposurePromise = syncExposure(locationVM.publicID.value);
            showProgressDialog(platformMessages.syncing, syncExposurePromise);
            syncExposurePromise.then((location) => {
                _.set(locationVM, 'value', location.value);
                setShowPolicyLocationQuestionSet(locationVM.locationQuestionSet.value !== undefined);
                locationVM.value.isEditing = true;
                isInSync = false;
                onModelChange(locationVM);
            });
        }
    }, []);

    const syncAddressChange = (value) => {
        locationVM.address.value = value;
        if (isEndorsement) {
            validateAndSyncExposure();
        } else if (locationVM.aspects.valid && locationVM.aspects.subtreeValid && !locationVM.locationQuestionSet.value) {
            performSync();
        }
        locationVM.address.validateAddressStatus_ML.value = false;
        onModelChange(locationVM);
    };

    const syncExcludeLocationChange = (value) => {
        locationVM.isExcluded.value = value;
        onModelChange(locationVM);
    };

    const onLocationValueChange = (value) => {
       locationVM.locationType.value = value;
       clearLocationDependentFields(true);
       //  No sync here — useEffect handles it once user fills required fields
       onModelChange(locationVM);
    };

    const syncUnderlyingPolicyChange = (value) => {
        locationVM.ulPolicyFixID.value = value;
        if (locationVM.ulPolicyFixID.value === 'new') {
            addNewUnderlyingPolicyIfNew();
        }
        onModelChange(locationVM);
    };

    const clearLocationDependentFields = (isLocationTypeChange) => {

        if (!isLocationTypeChange) {
            return;
        }

        if (locationVM.residenceType?.value !== undefined) {
            locationVM.residenceType.value = undefined;
        }

        if (locationVM.dwellingOccupancy?.value !== undefined) {
            locationVM.dwellingOccupancy.value = undefined;
        }
    
        if (locationVM.dwellingUsage?.value !== undefined) {
            locationVM.dwellingUsage.value = undefined;
        }

        if (locationVM.ulPolicyFixID?.value !== undefined) {
            locationVM.ulPolicyFixID.value = undefined;
        }
    
        if (locationVM.locationQuestionSet.value !== undefined) {
            locationVM.locationQuestionSet.value = undefined;
        }


        setShowPolicyLocationQuestionSet(false);

    };

    const validateDwellingFields = () => {
    
        const locationType = _.get(locationVM,'locationType.value.code') || _.get(locationVM,'locationType.value');
     
        clearBlockAlerts('Dwelling Fields Error');
    
        if (locationType !== 'Dwelling') {
            return false;
        }
     
        const residenceType = _.get(locationVM,'residenceType.value');
        const dwellingOccupancy = _.get(locationVM,'dwellingOccupancy.value');
        const dwellingUsage = _.get(locationVM,'dwellingUsage.value');
     
        if (_.isNil(residenceType)) {
            const message = translator(messages.residenceTypeRequiredErrorMessage);
            addErrorAlert(message,'Dwelling Fields Error');
            window.scrollTo(0, 0);
            return true;
    
        }
     
        if (_.isNil(dwellingOccupancy)) {
            const message = translator(messages.dwellingOccupancyRequiredErrorMessage);
            addErrorAlert(message,'Dwelling Fields Error');
            window.scrollTo(0, 0);
            return true;
        }
     
        if (_.isNil(dwellingUsage)) {
           const message = translator(messages.dwellingUsageRequiredErrorMessage);
            addErrorAlert(message,'Dwelling Fields Error');
            window.scrollTo(0, 0);
            return true;
        }
     
        return false;
    
    };

    const validateDwellingQuestions = () => {
        if(locationVM.locationType.value.code !== "Dwelling") {
            return true;
        }

        const questionSets = _.get(locationVM,'locationQuestionSet.value.questionSets',[]);

        const locationQuestionSet = _.find(
            questionSets,
            questionSet => questionSet.code === 'PUPPolicyLocation_ML'
        );

        const answers = _.get(locationQuestionSet, 'answers', {});

        const swimmingPool = _.get(answers,'PUPPolicyLocationSwimmingPool_ML');
        const poolFenced =  _.get(answers,'PUPPolicyLocationPoolFenced_ML');
        const trampoline = _.get(answers,'PUPPolicyLocationTrampoline_ML');
        const trampolineNet = _.get(answers,'PUPPolicyLocationTrampolineNet_ML');
        const hasAnimals = _.get(answers,'PUPPolicyLocationHasAnimals_ML');

        clearBlockAlerts('Location Error');

        if (_.isNil(swimmingPool) || _.isNil(trampoline) || _.isNil(hasAnimals) || (swimmingPool === "true" && _.isNil(poolFenced)) || (trampoline === "true" && _.isNil(trampolineNet))) {
            setLocationError(translator(messages.requiredDwellingQuestions));
            return false;
        }

        return true;

    };

    const onSaveDetails = useCallback(() => {
        if (!(locationVM.aspects.valid && locationVM.aspects.subtreeValid)) {
            updateShowErrors(true);
            if(setErrorTimestamp && errorTimestamp !== undefined){
                setErrorTimestamp(errorTimestamp+1);
            }
            return false;
        }
        if (isModernProduct && validateDwellingFields()) {
            return;
        }
        if(isUMB_NP && !validateDwellingQuestions()) {
            return false;
        }
        if (onSave) {
            return onSave(locationVM);
        }
        return false;
    }, [errorTimestamp, locationVM, onSave, setErrorTimestamp]);

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            questionset: QuestionSetComponent,
            mladdressdetailscomponent: MLAddressDetailsComponent
        },
        resolveCallbackMap: {
            onSaveDetails: onSaveDetails,
            onCancel: onCancel
        }
    };

    useEffect(() => {
        if (isEndorsement) {
            validateAndSyncExposure();
        } else if (locationVM.aspects.valid && locationVM.aspects.subtreeValid && !locationVM.locationQuestionSet.value) {
            performSync();
        }
       
    }, [locationVM.value, locationVM.value.residenceType, locationVM.value.dwellingOccupancy, locationVM.value.dwellingUsage, locationVM.value.isExcluded,locationVM.value.ulPolicyFixID]);

    
    const getInputStyle = useCallback(() => {
        return isAMP ? 'col-md-6' : 'col-md-4';
    }, [isAMP]);

    const getTootipStyle = useCallback(() => {
        return classNames(styles.tooltipContainerOverride, isAMP ? 'col-md-6' : 'col-md-8');
    }, [isAMP]);

    const isDwellingLocation = () => locationVM.locationType.value?.code === 'Dwelling';

    const overrides = {
        errorNotificationonLocation: {
            visible: !_.isNil(locationError),
            message: locationError
        },
        locationTypeSelect: {
            className: getInputStyle()
        },
        locationTypeTooltipContainer: {
            className: getTootipStyle()
        },
        underlyingPoliciesRow: {
            className: getInputStyle()
        },
        underlyingPolicyTooltipContainer: {
            className: getTootipStyle()
        },
        dwellingOccupancyControl: {
            className: getInputStyle()
        },
        dwellingUsageControl: {
            className: getInputStyle()
        },
        dwellingUsageTooltipContainer: {
            className: getTootipStyle()
        },
        residenceTypeSection: {
            visible: !isUMB_NP ?  notVacantLand() :  isDwellingLocation() || locationVM.residenceType.aspects.required
        },
        excludeLabel: {
            visible: !isUMB_NP ? true  : isDwellingLocation() || locationVM.isExcluded.aspects.required
        },
        excludeLocationSection: {
            visible: !isUMB_NP ? true  : isDwellingLocation() || locationVM.isExcluded.aspects.required
        },
        excludeLocationTooltipContainer: {
            visible: !isUMB_NP ? true  : isDwellingLocation() || locationVM.isExcluded.aspects.required
        },
        dwellingUsageSection: {
            visible: !isUMB_NP ?  notVacantLand() :  isDwellingLocation() || locationVM.dwellingOccupancy.aspects.required,
        },
        dwellingOccupancySection: {
            visible: !isUMB_NP ?  notVacantLand() :  isDwellingLocation() || locationVM.dwellingOccupancy.aspects.required,
        },
        policyLocationQuestionSetsSection:{
            visible: !isUMB_NP ?  notVacantLand() : showPolicyLocationQuestionSet
        },
        policylocationquestionset: {
            visible: showPolicyLocationQuestionSet,
            labelPosition: 'top',
            onValidate: setComponentValidation,
            showHeaderML: false,
            onValueChange: onQuestionSetValueChange,
            onBlur: onQuestionSetStringBlur
        },
        locationanimalsquestionset: {
            visible: _.get(locationVM, 'locationQuestionSet.questionSets.value', []).some((qs) => qs.code === locationAnimals) && showAnimalQuestions === true,
            labelPosition: 'top',
            onValidate: setComponentValidation,
            showHeaderML: false,
            onValueChange: onQuestionSetValueChange,
            onBlur: onQuestionSetStringBlur
        },
        locationType: {
            availableValues: getAvailableLocationTypes(),
            onValueChange: onLocationValueChange,
        },
        residenceType: {
            availableValues: getAvailableResidenceTypes()
        },
        addressDetailsComponent: {
            addressVM: locationVM.address,
            onModelChange: syncAddressChange,
            layout: 'ml-policy-change',
            onValidate: onValidate,
            showValidationErrors: showErrors
        },
        excludeLocationRadioButton: {
            onValueChange: syncExcludeLocationChange,
        },
        dwellingOccupancy: {
            availableValues: getAvailableDwellingOccupancies()
        },
        dwellingUsage: {
            availableValues: getAvailableDwellingUsages()
        },
        underlyingPolicies: {
            onValueChange: syncUnderlyingPolicyChange,
            availableValues: getUnderlyingPolicies()
        },
        actionRow: {
            visible: showActionRow,
            className: classNames('row col-md-12', isGPA ? 'gpa-modal-footer' : 'modal-footer')
        },
        cancelButton: {
            visible: isGPA
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            model={locationVM}
            onValidationChange={setComponentValidation}
            showErrors={showErrors || showValidationErrors}
            onModelChange={onModelChange}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

LocationPopupComponent.propTypes = {
    id: PropTypes.string,
    onValidate: PropTypes.func,
    showValidationErrors: PropTypes.bool,
    pupModel: PropTypes.shape({}).isRequired,
    locationVM: PropTypes.shape({}).isRequired,
    onModelChange: PropTypes.func.isRequired,
    syncExposure: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    getUnderlyingPolicies: PropTypes.func.isRequired,
    createUnderlyingPolicy: PropTypes.func,
    quoteID: PropTypes.string.isRequired,
    isEndorsement: PropTypes.bool,
    showAnimalExclusionWarningMessage: PropTypes.func,
    validateBeforeSave: PropTypes.func,
    showActionRow: PropTypes.bool,
    onCancel: PropTypes.func.isRequired
};

LocationPopupComponent.defaultProps = {
    id: undefined,
    onValidate: undefined,
    showValidationErrors: undefined,
    isEndorsement: undefined,
    showActionRow: true
};

export default LocationPopupComponent;
